import _slicedToArray from "/opt/peech/reactor/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useCallback, useEffect, useLayoutEffect } from 'react';
import { strictEqual, isClientSide } from './utils';

var identity = function identity(v) {
  return v;
};

export var useEntity = function useEntity(entity) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  var equality = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEqual;
  if (!(entity._subscribers instanceof Set)) throw new Error('Invalid entity.');

  var _useState = useState(transform(entity._value)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var subscriberFn = useCallback(function (newValue) {
    var newComputed = transform(newValue);
    var hasChanged = !equality(state, newComputed);
    if (hasChanged) setState(newComputed);
  }, [transform, equality, state]);
  var useIsoEffect = isClientSide() ? useLayoutEffect : useEffect;
  useIsoEffect(function () {
    return entity._subscribe(subscriberFn);
  }, [subscriberFn, entity]); // Re-sync state in case transform function has changed

  subscriberFn(entity._value);
  return state;
};
export default useEntity;